<template>
	<div>
		<GmapMap :center="center" :zoom="6" style="width: 100%; height: 500px">
			<GmapMarker
			:key="index"
			v-for="(m, index) in markers"
			:position="m.position"
			:clickable="true"
			:draggable="false"
			@click="center=m.position"
			@mouseover="statusText = m.text"
			@mouseout="statusText = null"
			/>
		</GmapMap>
	</div>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    data(){
      return{
        statusText: '',
        center: {},
        markers: [],
      };
    },
    computed: {
      ...mapState({
        // eslint-disable-next-line no-confusing-arrow
        getAllBranches: state => state.requests ? state.requests.allBranches : [],
      }),
    },
    async mounted() {
      await this.$store.dispatch('requests/getAllBranches');
      this.markers = this.getAllBranches.map(b => ({
        position: { lat: parseFloat(b.latitude), lng: parseFloat(b.longitude) },
        text: b.name,
      }));
      // set the center of the map to the first marker
      this.center = this.markers[0].position;
    },
    methods: {
    }
  };
</script>